<div class="tracking-state-container">
  <div class="d-flex">
    <div *ngFor="let item of SHIPMENT_STATES; let i = index" class="state-item">
      <div class="test">
        <span class="state-item__circle" [ngClass]="{ 'state-item__circle-active': currentState >= i }">
          <img src="{{ item.icon }}" alt="{{ item.icon }}" />
        </span>
        <span class="state-item__label state-item__label-{{ i }}" [ngClass]="{ 'state-item__label-active': currentState === i }">
          {{ item.label }}
        </span>
      </div>
      <div class="line" *ngIf="i !== SHIPMENT_STATES.length - 1" [ngClass]="{ 'line-active': currentState > i }"></div>
    </div>
  </div>
</div>
